import { StylePresetKey } from "./enums.mjs";
import { z } from "zod";
//#region src/api/orpc/image/style.ts
/**
* The `style` field of an image creation request.
*
* Two mutually exclusive shapes, discriminated by `type`:
*   - `{ type: 'preset', key }`   — choose one of the curated `StylePresetKey`s.
*   - `{ type: 'custom', custom }` — free-form prompt fragment.
*/
const StyleSchema = z.discriminatedUnion("type", [z.object({
	type: z.literal("preset"),
	key: StylePresetKey
}), z.object({
	type: z.literal("custom"),
	custom: z.string().min(1)
})]);
//#endregion
export { StyleSchema };
